import { Machine } from '../../types/machines/machine.types';

/**
 * The short identifier shown next to the name. `displayName` falls back to
 * `machineId`, so it is omitted when the two match and it would print twice.
 */
export function getMachineShortId(machine: Machine): string | null {
  const name = machine.displayName || machine.machineId;
  return machine.machineId && machine.machineId !== name
    ? machine.machineId
    : null;
}

/** Where the machine stands: the customer record's name, then the plant. */
export function getMachineLocation(machine: Machine): string {
  return [machine.customerName, machine.plant].filter(Boolean).join(' • ');
}
